import { getKvlist, addKv, deleteKv, updateKv, updateKvByKey } from '@/graphql/api/kv';

export const GetKvlist = (data = {}) => getKvlist(data); // 获取列表

export const AddKv = (data = {}) => addKv(data); // 新增

export const DeleteKv = (data = {}) => deleteKv(data); // 删除

export const UpdateKv = (data = {}) => updateKv(data); // 删除

export const UpdateKvByKey = (data = {}) => updateKvByKey(data); // 删除
